import { environment } from "src/environments/environment";
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnInit,
  Output,
} from "@angular/core";
import { authData } from "src/app/util/auth";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";
import { DataService } from "src/app/http/data.service";

@Component({
  selector: "app-navigation-drawer",
  templateUrl: "./navigation-drawer.component.html",
})
export class NavigationDrawerComponent implements OnInit {

  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private dataService: DataService
  ) {}
  showStreamPopup: boolean = false;
  showElectivePopup: boolean = false;
  notification = {};
  open = false;
  _checks = authData("_checks");
  _isApplication = authData("_isApplication");
  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + authData().Token,
    }),
  };

  links =  [
    {
      name: "home",
      title: "Dashboard",
      slug: "/",
      icon: "grid_view",
    },
    {
      name: "biodata",
      title: "Student Data",
      slug: "/bio-data",
      icon: "contact_page",
    },
    {
      name: "payment",
      title: "Payments",
      slug: "/payments",
      icon: "credit_card",
    },
    {
      name: "result",
      title: "Results",
      slug: "/results",
      icon: "fact_check",
    },
    {
      name: "application",
      title: "Student Applications",
      slug: "/application",
      icon: "note_alt",
    },
    {
      name: "accommodation",
      title: "Accommodation",
      slug: "/accommodation",
      icon: "house",
    },
    {
      name: "purchases",
      title: "Purchases",
      slug: "/purchases",
      icon: "shopping_cart",
    },
  ];
  xLinks: Link[] = [];

  async ngOnInit(): Promise<void> {
    this.dataService.getData().subscribe((data) => {
      this.open = data;
    });

    const navItems: any = [];
    const navLinks: any = environment.nav_links;
    Object.keys(navLinks).forEach((x: any) => {
      if (navLinks[x]) navItems.push(x);
    });

    this.links = this.links.filter((el) => navItems.includes(el.name));

      await this.fetchChecks();

    // if (this._checks.EnableWebTest || !this._isApplication)
    //   this.xLinks.push({
    //     title: "Webtest",
    //     isImpata: false,
    //     icon: "/assets/logos/webtest.png",
    //   });
    // if (this._checks.EnableImpata || !this._isApplication)
      this.xLinks.push({
        title: "Impata",
        isImpata: true,
        icon: "/assets/logos/impata.png",
      });
  }

  external(isImpata: boolean) {
    var baseUrl = `${environment.BASE_URL}/users/impata`;

    if (!isImpata) baseUrl = `${environment.BASE_URL}/users/webtest`;

    this.httpClient.get(baseUrl, this.httpOptions).subscribe({
      next: (res: any) => {
        if (res.Success) {
          
          window.open(res.Data, "_blank");
        } else {
          this.router.navigateByUrl(`/#${res.Message}`);
        }
      },
      error: (err: any) => {
        this.router.navigateByUrl(`/#${err.error.Message}`);
      },
    });
  }
  performFetchChecks(message: any) {
    if (message) {
      this.notification = {
        error: false,
        message: message,
      };
    }
    this.fetchChecks();
    if (!this.showStreamPopup && !this.showElectivePopup) {
      this.router.navigateByUrl(`#${message.replaceAll(" ","+")}#success`);
    }

  }
  fetchChecks(): Promise<any> {
    return new Promise((resolve) => {
      this.dataService.fetchChecks(this._isApplication, true).subscribe({
        next: (_res: any) => {
          if (!_res) return;
          this._checks = authData("_checks");
          if (!this._checks.ShowAccommodation) {
            this.links = this.links.filter((el) => el.name !== 'accommodation');
          }
          this.showStreamPopup = this._checks.ShowStreamPopup;
          this.showElectivePopup = !this.showStreamPopup && this._checks.ShowElectivePopup;
          resolve(this._checks);
        },
        error: () => resolve(null),
      });
    });
  }
}

interface Link {
  title: string;
  isImpata: boolean;
  icon: string;
}

